module.exports = __webpack_public_path__ + "media/images/redesign-images/collabs/influencers/icon-your-logo-e062a114473099e67234ebcb0368f80f.svg";